import { LabelColor } from "@components/Label";
import { PurchaseRequisitionStatus } from "../types/purchaseRequisitionTypes";

const statusOptionsMap: Record<PurchaseRequisitionStatus, string> = {
  [PurchaseRequisitionStatus.Draft]: "draft",
  [PurchaseRequisitionStatus.Submitted]: "submitted",
  [PurchaseRequisitionStatus.Discard]: "discarded",
  [PurchaseRequisitionStatus.Posted]: "posted",
};

const statusLabelMap: Record<
  PurchaseRequisitionStatus,
  { translationKey: string; color: LabelColor }
> = {
  [PurchaseRequisitionStatus.Draft]: {
    translationKey: "draft",
    color: "warning",
  },
  [PurchaseRequisitionStatus.Submitted]: {
    translationKey: "submitted",
    color: "info",
  },
  [PurchaseRequisitionStatus.Discard]: {
    translationKey: "discarded",
    color: "error",
  },
  [PurchaseRequisitionStatus.Posted]: {
    translationKey: "posted",
    color: "success",
  },
};

export { statusLabelMap, statusOptionsMap };
